export const domain = 'EntityHistoryModel'

export const onSetEntityHistory = `${domain}/onSetEntityHistory`
